var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-image"},[_c('img',{staticClass:"field-media",class:{'scale-type':!_vm.media.ext_val_scaleType},attrs:{"src":_vm.media.field_item_path,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }